/**
 * Total segun la cantidad elegida en la ficha de producto.
 *
 * Escucha el formulario de compra y recalcula sin pedir nada al servidor:
 * los precios de cada variante vienen publicados en la pagina.
 *
 * Si la app de descuentos esta mostrando su propia calculadora (que ademas
 * descuenta), esta linea se aparta: dos totales distintos en la misma ficha
 * confunden mas de lo que informan.
 */

(function () {
  "use strict";

  var CENTAVOS = 100;

  function formatearMoneda(valorEnCentavos) {
    // El tema expone su formato de moneda; si no, se cae a un formato local.
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(
          valorEnCentavos,
          window.Shopify.money_format || window.moneyFormat,
        );
      } catch (e) {
        /* se usa el respaldo de abajo */
      }
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "es-CL", {
        style: "currency",
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "CLP",
        maximumFractionDigits: 0,
      }).format(valorEnCentavos / CENTAVOS);
    } catch (e) {
      return String(Math.round(valorEnCentavos / CENTAVOS));
    }
  }

  function iniciar(nodo) {
    var seccion = nodo.dataset.seccion;
    var etiquetaJson = document.querySelector("[data-precios-variante-" + seccion + "]");
    if (!etiquetaJson) return;

    var precios;
    try {
      precios = JSON.parse(etiquetaJson.textContent);
    } catch (e) {
      return;
    }

    var salida = nodo.querySelector(".precio-total__texto");
    var plantilla = nodo.dataset.etiqueta || "Total por __N__ unidades:";

    function formulario() {
      // Se sube por el arbol buscando el formulario de compra. Dos matices:
      //
      //  1. Hay que elegir el del contenedor mas cercano: con el panel de
      //     compra rapida abierto coexiste con el de la ficha de abajo.
      //  2. No vale el primero que aparezca. Tanto la ficha como el panel
      //     incluyen un segundo formulario a /cart/add para el mensaje de
      //     cuotas, que va ANTES en el DOM y no tiene selector de cantidad.
      //     Se exige que el formulario tenga campo de cantidad.
      var el = nodo;
      var respaldo = null;

      while (el) {
        if (el.querySelectorAll) {
          var formularios = el.querySelectorAll('form[action*="/cart/add"]');
          for (var i = 0; i < formularios.length; i++) {
            if (formularios[i].querySelector('[name="quantity"]')) {
              return formularios[i];
            }
            if (!respaldo) respaldo = formularios[i];
          }
        }
        el = el.parentElement;
      }
      return respaldo || document.querySelector('form[action*="/cart/add"]');
    }

    function repintar() {
      // La app de descuentos ya muestra su propio total, con descuento.
      var calculadoraApp = document.querySelector(".vitrina-calculadora");
      if (calculadoraApp && calculadoraApp.offsetParent !== null) {
        nodo.hidden = true;
        return;
      }

      var form = formulario();
      if (!form) return;

      var campoCantidad = form.querySelector('[name="quantity"]');
      var campoVariante = form.querySelector('[name="id"]');
      var cantidad = campoCantidad ? parseInt(campoCantidad.value, 10) : 1;
      if (!isFinite(cantidad) || cantidad < 1) cantidad = 1;

      // Con una unidad el precio de arriba ya lo dice todo.
      if (cantidad < 2) {
        nodo.hidden = true;
        return;
      }

      var dato =
        (campoVariante && precios[campoVariante.value]) ||
        precios[Object.keys(precios)[0]];
      if (!dato) {
        nodo.hidden = true;
        return;
      }
      // Formato antiguo: solo el precio. Nuevo: precio + ahorro de la campaña vigente; un monto
      // «una vez por pedido» se descuenta una sola vez, como en el carro.
      if (typeof dato === "number") dato = { precio: dato, ahorro: 0, unaVez: false };
      // Sin campaña propia, el descuento de Regios Discounts (assets/regios-precios.js)
      if (!dato.ahorro && window.RegiosPrecios && etiquetaJson.dataset.regiosProductoTotal) {
        var regios = window.RegiosPrecios.calcular({
          id: etiquetaJson.dataset.regiosProductoTotal,
          variante: campoVariante ? String(campoVariante.value) : "",
          colecciones: (etiquetaJson.dataset.regiosColecciones || "").split(",").filter(Boolean),
        }, dato.precio, 0);
        if (regios) dato = { precio: dato.precio, ahorro: dato.precio - regios.final, unaVez: regios.unaVez };
      }
      var total = dato.precio * cantidad - (dato.unaVez ? dato.ahorro : dato.ahorro * cantidad);

      salida.textContent =
        plantilla.replace("__N__", cantidad) + " " + formatearMoneda(total);
      nodo.hidden = false;
    }

    repintar();

    var form = formulario();
    if (form) {
      form.addEventListener("input", repintar);
      form.addEventListener("change", repintar);
    }
    // Al cambiar de variante algunos temas rehacen el formulario entero, y el
    // panel de compra rapida se inyecta despues: se vuelve a pintar ante
    // cualquier cambio del documento, que es barato y evita quedarse obsoleto.
    document.addEventListener("change", repintar);
    document.addEventListener("variant:change", repintar);
  }

  function arrancar() {
    document.querySelectorAll("[data-precio-total]").forEach(function (n) {
      if (n.dataset.precioIniciado === "1") return;
      n.dataset.precioIniciado = "1";
      iniciar(n);
    });
  }

  // El panel de compra rapida se inyecta al abrirlo, asi que hay que
  // enganchar las lineas nuevas cuando aparecen.
  function vigilarNuevas() {
    var pendiente = null;
    new MutationObserver(function () {
      clearTimeout(pendiente);
      pendiente = setTimeout(arrancar, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      arrancar();
      vigilarNuevas();
    });
  } else {
    arrancar();
    vigilarNuevas();
  }
})();
